module.exports = __webpack_public_path__ + "static/img/logo-8.70778dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/svg-img/logo-8.svg
// module id = 1397
// module chunks = 4